@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(610_192_215)
internal val Res.font.NotoSansEgyptianHieroglyphs_Regular: FontResource by lazy {
      FontResource("font:NotoSansEgyptianHieroglyphs_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/NotoSansEgyptianHieroglyphs-Regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_835_654_260)
internal val Res.font.NotoSans_Regular: FontResource by lazy {
      FontResource("font:NotoSans_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/NotoSans-Regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_550_871_971)
internal val Res.font.Roboto_Condensed_Medium: FontResource by lazy {
      FontResource("font:Roboto_Condensed_Medium", setOf(
        ResourceItem(setOf(), "${MD}font/Roboto_Condensed-Medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_353_789_129)
internal val Res.font.Roboto_Medium: FontResource by lazy {
      FontResource("font:Roboto_Medium", setOf(
        ResourceItem(setOf(), "${MD}font/Roboto-Medium.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("NotoSansEgyptianHieroglyphs_Regular", Res.font.NotoSansEgyptianHieroglyphs_Regular)
  map.put("NotoSans_Regular", Res.font.NotoSans_Regular)
  map.put("Roboto_Condensed_Medium", Res.font.Roboto_Condensed_Medium)
  map.put("Roboto_Medium", Res.font.Roboto_Medium)
}
